<template>
  <modal @close="close" width="100%" :click-to-close="false">
    <h3 slot="header">Ejecución de Conceptos</h3>

    <loading-content :error="!!error" :loading="loading" v-if="loading || error" />
    <template v-else-if="quantification">
      <tabs
        :options="{
          useUrlFragment: false,
          defaultTabHash: '#conceptos',
        }"
      >
        <tab name="Alcance">
          <quantification-form v-model="realScope" :plannedScope="plannedScope"></quantification-form>
        </tab>
        <tab name="Conceptos">
          <quantities-table
            @clickedConcept="showConceptFiles"
            :concepts="concepts"
            :file-types="fileTypes"
          />
        </tab>
      </tabs>
    </template>
    <template slot="footer">
      <md-button class="md-success" :disabled="loading" @click="sendRealQuantities">
        <md-icon>save</md-icon>Guardar
      </md-button>
      <md-button @click="close">
        <md-icon>exit</md-icon>Cancelar
      </md-button>
    </template>
  </modal>
</template>

<script>
import QuantificationForm from "./QuantificationScopes";
import QuantitiesTable from "./QuantitiesTable";
import purchaseService from "@/services/purchase/";
import { fetchConcepts } from "@/services/purchase/lifting";
import fileService from "@/services/Files";
import FilesModal from "@/pages/RoadSinisters/File/Lifting/FilesModal";

export default {
  name: "QuantitiesModal",

  components: {
    QuantitiesTable,
    FilesModal,
    QuantificationForm,
  },

  props: {
    affectedId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      concepts: [],
      error: null,
      // not computed because its stateful
      quantification: null,
      conceptsWithRealExecution: [],
      realQuantities: null,
      activeConcept: null,
      fileTypes: [],
      liftingConceptsData: [],
      realScope: {},
    };
  },

  computed: {
    conceptsData() {
      const { realQuantities, concepts } = this;
      return {
        realQuantities,
        concepts,
      };
    },
    plannedScope() {
      const {
        scope = 0,
        masters = 0,
        officials = 0,
        assistants = 0,
        flagWorkers = 0,
      } = this.quantification || {};
      return { scope, masters, officials, assistants, flagWorkers };
    },
  },

  watch: {
    conceptsData: {
      immediate: true,
      handler: "updateConceptsWithRealExecution",
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    fetchQuantification() {
      this.loading = true;
      const { affectedId } = this;
      return purchaseService
        .fetchQuantification(affectedId)
        .then((quantification) => {
          this.loading = false;

          if (!quantification) {
            this.error = "No hay cuantificacion";
            return;
          }

          this.quantification = quantification;

          this.concepts = quantification.concepts
            .filter(({ notToDo }) => !notToDo)
            .map((c) => {
              return {
                ...c,
              };
            });

          // Load real scope
          const {
            avegareMWorkers,
            avegareOWorkers,
            avegareFWorkers,
            avegareAWorkers,
            workedDays,
          } = quantification;
          this.realScope = {
            avegareMWorkers,
            avegareOWorkers,
            avegareFWorkers,
            avegareAWorkers,
            workedDays,
          };
        })
        .catch(this.$fireErrorResponse)
        .finally(() => {
          this.loading = false;
        });
    },
    fetchRealQuantities() {
      this.loading = true;
      const { affectedId } = this;
      return purchaseService
        .fetchRealQuantities(affectedId)
        .then((realQuantities) => {
          this.realQuantities = realQuantities;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => {
          this.loading = false;
        });
    },
    fetchLiftingData() {
      const {
        quantification: { id },
      } = this;
      return fetchConcepts({ id }).then((concepts) => {
        this.liftingConceptsData = concepts;
      });
    },
    sendRealQuantities() {
      this.loading = true;
      const { affectedId, concepts, realScope } = this;
      const quantities = concepts.map(({ id, realQuantity }) => ({
        id,
        realQuantity,
      }));
      purchaseService
        .sendRealQuantities(affectedId, quantities, realScope)
        .then(() => {
          this.$successMessage({
            title: "Las cantidades reparadas se guardaron correctamente",
          });
          this.close();
        })
        .catch(this.$fireErrorResponse)
        .finally(() => {
          this.loading = false;
        });
    },
    updateConceptsWithRealExecution() {
      const { realQuantities, concepts } = this.conceptsData;
      let conceptsWithRealExecution = [...concepts];
      if (realQuantities) {
        conceptsWithRealExecution = concepts.map(({ id, ...c }) => {
          const realQuantity = realQuantities.find(({ id: rId }) => rId === id);
          return {
            ...c,
            id,
            realExecutedQuantity: realQuantity
              ? realQuantity.quantityExecuted
              : -1,
          };
        });
      }

      this.conceptsWithRealExecution = conceptsWithRealExecution;
    },
    showConceptFiles(concept) {
      this.activeConcept = concept;
    },
    hideConceptFiles() {
      this.activeConcept = null;
    },
    fetchFileTypes() {
      return fileService.fetch("filetype").then((fileTypes) => {
        this.fileTypes = fileTypes;
      });
    },
  },

  mounted() {
    this.fetchFileTypes();
    this.fetchQuantification().then(() => {
      this.fetchLiftingData();
    });
  },
};
</script>

<style lang="scss" scoped>
.md-button.close-files-btn {
  margin-top: -32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/ConceptsModal.vue